import script from "./TheAdminLog.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAdminLog.vue?vue&type=script&setup=true&lang=js"

import "./TheAdminLog.vue?vue&type=style&index=0&id=28314217&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28314217"]])

export default __exports__